import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { DELETE_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import type { BaseError } from '@utils/types/shared/base.ts';

async function disconnectConnection(connectionId: string): Promise<void> {
  await Axios.delete(DELETE_URL(connectionId).deleteConnection);
}

export function useDisconnectConnection() {
  const queryClient = useQueryClient();

  return useMutation<void, AxiosError<BaseError>, string>(
    disconnectConnection,
    {
      onSuccess: () => {
        queryClient.invalidateQueries(QueryKeys.connections());
      },
      useErrorBoundary: false
    }
  );
}
